
import device from '../assets/device.png'
import dropList from '../assets/dropList.png'
import icon from '../assets/icon.png'
import user from '../assets/user.png'
import Deleteimg from '../assets/delete.png'
import editingimg from '../assets/editing.png'
import logo from '../assets/logo.png'
import report from '../assets/report.png'
import brand from '../assets/brand.png'
import graph1 from '../assets/graph1.png'
import graph2 from '../assets/graph2.png'
import patientsIcon from '../assets/PatientsIcon.png'
import TestsIcon from '../assets/TestIcon.png'
import HospitalIcon from '../assets/HospitalIcon.png'
import sidebarIcon from '../assets/sidebarIcon.png'
import devicesIcon from '../assets/devicesIcon.png'

const application_contants = { 
  Deleteimg : Deleteimg,
  editingimg : editingimg,
  user : user,
  icon : icon,
  device : device,
  dropList : dropList,
  logo : logo,
  report: report,
  brand: brand,
  graph1: graph1,
  graph2: graph2,
  patientsIcon: patientsIcon,
  TestsIcon: TestsIcon,
  HospitalIcon: HospitalIcon,
  sidebarIcon: sidebarIcon,
  devicesIcon : devicesIcon,

  
  LANDING: '/',
  Home : '/Home',
  Patients: '/Patients',
  Test: '/Test',
  Hospitals: '/Hospital',
  Devices: '/Devices',

  
  ABOUTUS: '/aboutUs',
 

  MOBILE_BREAKPOINT: 1023,
};


export default application_contants;
